import { defineStore } from 'pinia'
import { LlmSourcesState } from './types'

const initialState = (): LlmSourcesState => ({ sources: {} })

// IMPROVEME(TEA-336): replace highlighted quotes store with vuequery
export const useLlmSourcesStore = defineStore('llmSources', {
  state: initialState,
  actions: {
    setQuotesForSource(sourceId: string, quotes: string[]) {
      if (!sourceId) return
      this.sources[sourceId] = quotes
    },
    getQuotesForSource(sourceId: string) {
      return this.sources[sourceId] ?? []
    },
    clearAll() {
      this.sources = {}
    },
  },
})
